// Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// Material
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
// RxJS
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AppState } from '../../../../../../core/reducers';
// Layout
// CRUD
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
// Services and Models
import {
  ContactModel,
  ContactOnServerCreated,
  ContactOnServerUpdated,
  ContactsService,
  NoteEntityType,
  selectContactErrorState,
  selectContactsActionLoading,
  selectLastCreatedContact,
  SharedHttpRequestService,
  ViewContext,
} from '../../../../../../core/lists';
import { AuthService, currentUser, currentUserPermissions } from 'src/app/core/auth';
import { TranslateService } from '@ngx-translate/core';
import { tagsViewContext } from '../../../../../../core/lists/_services/shared-http-request.service';
import { DatePipe } from '@angular/common';
import { MergeContactsComponent } from '../_subs/merge-contacts/merge-contacts.component';
import { GeneralValidationMessagesService } from '../../../../../../core/services/general-validation-messages.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { LanguagePreference } from '../../../../../../core/lists/_models/languagePreference.model';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { ViewFileDialogComponent } from '../../../../../partials/content/crud/view-file-dialog/view-file-dialog.component';
import { filter, take } from 'rxjs/operators';
import { ZoomInEntityComponent } from '../../../../../partials/content/general/zoom-in-entity/zoom-in-entity.component';
import { NavigationService } from '../../../../../../core/services/navigation.service';
import { PictureCropperComponent } from '../../../../../partials/content/general/picture-cropper/picture-cropper.component';
import { ImageSettingService } from '../../../../../../core/services/image-setting.service';
import { setSelectedCellPhone } from '../contact-duplicate-cell-number/store/actions/contact-duplicate-cell-phone.actions';
import { ContactDuplicateCellNumberComponent } from '../contact-duplicate-cell-number/contact-duplicate-cell-number.component';
import { selectSelectedCellPhone } from '../contact-duplicate-cell-number/store/selectors/contact-duplicate-cell-phone.selectors';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-contact-edit',
  templateUrl: './contact-edit.component.html',
  styleUrls: ['./contact-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactEditComponent implements OnInit, OnDestroy {
  // for HTML template use
  NoteEntityType = NoteEntityType;
  //
  contact: ContactModel;
  contactId$: Observable<number>;
  companyId: number;
  companyUUID: string;
  oldContact: ContactModel;
  selectedTab = 0;
  maxDate: any;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  contactForm: FormGroup;
  hasFormErrors = false;
  isViewMode: boolean;
  isViewMode$: Observable<boolean>;
  private headerMargin: number;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  private subscriptions: any[] = [];
  tags = new FormControl();
  tags$ = new BehaviorSubject<any>([]);
  loadingTags = true;
  readOnlyTags = [];
  urbanizationValue;
  Address1Value;
  Address2Value;
  cityValue;
  zipValue;
  languages: LanguagePreference[];
  private newAvatar = null;
  private needToChangeImage = false;
  basicInfo: any = {};
  formChanged = false;
  params: any;
  needToChange = false;
  historyResult;
  contactUsername = '';
  contactProfile;
  data = [];
  role: string;
  updating = false;
  contactFemaleDefault = '/assets/media/contacts/contactFemale.svg';
  contactMaleDefault = '/assets/media/contacts/contactMale.svg';
  contactUndefinedDefault = '/assets/media/contacts/contactUndefined.svg';
  view = false;
  tabs = [];
  loadingData = false;
  initialTabs = [
    { index: 0, label: 'General Info', icon: 'mat-tab-label-icon fa fa-info', active: true },
    {
      index: 1,
      label: 'Relations',
      icon: 'mat-tab-label-icon fas fa-people-arrows',
      active: false,
      permission: 'canViewRelation',
    },
    {
      index: 2,
      label: 'Notes',
      icon: 'flaticon-notes icon-md',
      active: false,
      permission: 'canViewNote',
    },
    {
      index: 3,
      label: 'Payment Methods',
      icon: 'mat-tab-label-icon fas fa-credit-card',
      active: false,
    },
    { index: 4, label: 'History', icon: 'mat-tab-label-icon fas fa-history', active: false },
    {
      index: 5,
      label: 'Login Details',
      icon: 'mat-tab-label-icon flaticon-avatar',
      active: false,
      permission: 'canViewLoginDetails',
    },
    {
      index: 6,
      label: 'login History',
      icon: 'mat-tab-label-icon fa fas fa-sign-in-alt',
      active: false,
      permission: 'canViewLoginDetails',
    },
  ];
  loadUsername = true;
  displayAffiliation = true;
  actionLoadingSubscription: Subscription;
  errorStateSubscription: Subscription;

  constructor(
    private datePipe: DatePipe,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private contactFB: FormBuilder,
    private layoutUtilsService: LayoutUtilsService,
    private contactService: ContactsService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private sharedHttpRequestService: SharedHttpRequestService,
    public dialog: MatDialog,
    private authService: AuthService,
    private globalService: GeneralValidationMessagesService,
    public stringUtils: StringUtilsService,
    private navigationService: NavigationService,
    private imageSettingService: ImageSettingService,
  ) {
    this.maxDate = new Date();
    window.addEventListener('beforeunload', (event) => {
      if (this.formChanged) {
        event.returnValue = 'You have unfinished changes!';
      }
    });
  }

  ngOnInit() {
    this.tabs = this.initialTabs;
    // this line due to make the navigation service return to contact list if there is no ->
    // navigation stack saved before in special cases
    this.navigationService.setDefaultRoot('/lists/contacts');

    this.activatedRoute.queryParams.subscribe((params) => {
      this.params = params;
      params.tab_index ? this.changeTab(+params.tab_index) : this.changeTab(0);
    });
    const userSub = this.store.pipe(select(currentUser)).subscribe((res) => {
      if (!res) {
        this.router.navigateByUrl('/lists/contacts');
      }
      this.companyId = res.companyID;
      this.companyUUID = res.companyUUID;
    });
    this.subscriptions.push({ id: 1, sub: userSub });
    this.loading$ = this.loadingSubject.asObservable();
    this.loadingSubject.next(true);
    const routeSub = this.activatedRoute.params.subscribe((params) => {
      const id = params.id;
      if (id && id > 0) {
        this.authService.getQRVEYMenu(id, 'CONTACT').subscribe((res) => {
          this.data = res.data[0]?.apps ? res.data[0].apps : null;
          this.role = res.data[0]?.role ? res.data[0].role : null;
          this.cdr.detectChanges();
        });
        const contactByIdSub = this.globalService
          .getEntitiesById('contacts', id)
          .subscribe((res) => {
            if (res) {
              this.loadContact(res.data);
              this.loadTags();
              this.cdr.detectChanges();
              return;
            }
          });
        this.subscriptions.push({ id: 2, sub: contactByIdSub });
      } else {
        const newContact = new ContactModel();
        newContact.clear();
        this.loadContact(newContact);
      }

      this.cdr.detectChanges();
    });
    this.subscriptions.push({ id: 3, sub: routeSub });

    this.contactService.getLanguagePreference().subscribe((result) => {
      this.languages = result ? result.data : [];
      this.cdr.detectChanges();
    });
  }

  loadContact(_contact, fromService = false) {
    if (!_contact) {
      this.goBack();
      return;
    }
    this.contact = _contact;
    setTimeout(() => {
      this.loadLoginHistory(_contact);
    }, 1000);
    this.contactId$ = of(_contact.id);
    this.oldContact = Object.assign({}, _contact);
    this.initContact();
    if (fromService) {
      this.cdr.detectChanges();
    }
    this.basicInfo = {
      avatar: this.contact.pre_signed_url?.url
        ? this.contact.pre_signed_url.url
        : this.contact.gender
        ? this.contact.gender === 'FEMALE'
          ? this.contactFemaleDefault
          : this.contactMaleDefault
        : this.contactUndefinedDefault,
    };
    this.contactProfile = this.basicInfo.avatar
      ? this.basicInfo.avatar
      : this.contactUndefinedDefault;

    // Tabs to display in create contact mode.
    if (!this.contact?.id) {
      this.tabs = this.initialTabs.filter((x) => x.index === 0);
    }
  }

  loadLoginHistory(contact) {
    const username = typeof contact?.username === 'string' ? contact.username.trim() : '';
    if (!contact?.id || !username) {
      this.historyResult = null;
      this.contactUsername = '';
      this.loadUsername = false;
      this.cdr.detectChanges();
      return;
    }
    const loginHistorySub = this.contactService.getLoginHistory(contact.id).subscribe(
      (res) => {
        this.historyResult = res;
        this.contactUsername = res?.username;
        this.loadUsername = false;
        this.cdr.detectChanges();
      },
      () => {
        this.historyResult = null;
        this.contactUsername = '';
        this.loadUsername = false;
        this.cdr.detectChanges();
      },
    );
    this.subscriptions.push({ id: 6, sub: loginHistorySub });
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  initContact() {
    this.createForm();
    this.loadingSubject.next(false);
    if (!this.contact.id) {
      this.isViewMode = false;
    } else if (this.activatedRoute.url[`_value`][1]?.path === 'view') {
      this.isViewMode = true;
      this.contactForm.disable();
    } else {
      this.subscriptions.push(
        this.store.pipe(select(currentUserPermissions)).subscribe((res) => {
          if (!res.some((p) => p.name === 'canEditContact')) {
            this.contactForm.disable();
          }
        }),
      );
      this.isViewMode = false;
    }
    this.isViewMode$ = of(this.isViewMode);
    this.displayAffiliation = !(this.activatedRoute.url[`_value`][1]?.path === 'add');
  }

  /**
   * Create form
   */
  createForm() {
    this.contactForm = this.contactFB.group({
      urbanization: [this.contact.urbanization, Validators.maxLength(48)],
      nickname: [this.contact.nickname],
      first_name: [this.contact.first_name, Validators.required],
      last_name: [this.contact.last_name, Validators.required],
      middle_name: [this.contact.middle_name],
      last_name2: [this.contact.last_name2],
      entity_id: [this.contact.entity_id],
      email: [this.contact.email, [Validators.email]],
      gender: [this.contact.gender ? this.contact.gender : ''],
      cell_phone: [
        this.contact.cell_phone !== '' && this.contact.cell_phone !== null
          ? '(' +
            this.contact.cell_phone.substring(0, 3) +
            ') ' +
            this.contact.cell_phone.substring(3, 6) +
            '-' +
            this.contact.cell_phone.substring(6, 10)
          : '',
        [Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/)],
      ],
      home_phone: [
        this.contact.home_phone !== '' && this.contact.home_phone !== null
          ? '(' +
            this.contact.home_phone.substring(0, 3) +
            ') ' +
            this.contact.home_phone.substring(3, 6) +
            '-' +
            this.contact.home_phone.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      phone2: [
        this.contact.phone2 && this.contact.phone2 !== ''
          ? '(' +
            this.contact.phone2.substring(0, 3) +
            ') ' +
            this.contact.phone2.substring(3, 6) +
            '-' +
            this.contact.phone2.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      fax: [
        this.contact.fax !== '' && this.contact.fax !== null
          ? '(' +
            this.contact.fax.substring(0, 3) +
            ') ' +
            this.contact.fax.substring(3, 6) +
            '-' +
            this.contact.fax.substring(6, 10)
          : '',
        [Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/)],
      ],
      state: [this.contact.state],
      pin_number: [this.contact.pin_number, Validators.pattern('^[0-9]*$')],
      city: [this.contact.city, Validators.compose([Validators.maxLength(30)])],
      zip: [
        this.contact.zip,
        Validators.compose([Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)]),
      ],
      address1: [this.contact.address_1, Validators.compose([Validators.maxLength(48)])],
      address2: [this.contact.address_2, Validators.maxLength(48)],
      isActive: [this.contact.is_active],
      note: [this.contact.note, Validators.maxLength(10000)],
      dob: [
        this.contact.dob !== null && this.contact.dob !== ''
          ? new Date(`${this.contact.dob}T00:00:00`)
          : '',
      ],
      language_preference: [this.contact.language ? this.contact.language.id : null],
      preferred_time: [this.contact.preferred_time ? this.contact.preferred_time : null],
      office_number: [
        this.contact.office_number !== '' && this.contact.office_number !== null
          ? '(' +
            this.contact.office_number.substring(0, 3) +
            ') ' +
            this.contact.office_number.substring(3, 6) +
            '-' +
            this.contact.office_number.substring(6, 10)
          : '',
        [Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/)],
      ],
      extension: [this.contact.extension],
    });
    this.urbanizationValue = this.contact.urbanization;
    this.Address1Value = this.contact.address_1;
    this.Address2Value = this.contact.address_2;
    this.cityValue = this.contact.city;
    this.zipValue = this.contact.zip;
    this.loadingData = true;
    setTimeout(() => {
      this.contactForm.valueChanges.subscribe(() => {
        this.formChanged = true;
        this.authService.setChanged(true);
      });
    }, 3000);
  }

  goBack() {
    this.loadingSubject.next(false);
    this.navigationService.goBack();
  }
  /**
   * Reset
   */
  reset() {
    this.contact = Object.assign({}, this.oldContact);
    this.createForm();
    this.hasFormErrors = false;
    this.contactForm.markAsPristine();
    this.contactForm.markAsUntouched();
    this.contactForm.updateValueAndValidity();
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.contactForm.controls;
    /** check form */
    if (this.contactForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());

      this.hasFormErrors = true;
      this.selectedTab = 0;
      return;
    }
    this.formChanged = false;
    this.authService.setChanged(false);
    // tslint:disable-next-line:prefer-const
    const editedContact = this.prepareContact();
    if (editedContact.id > 0) {
      this.updateContact(editedContact);
      return;
    }
    this.addContact(editedContact);
  }

  prepareContact(): ContactModel {
    const controls = this.contactForm.controls;
    const _contact = new ContactModel();
    _contact.id = this.contact.id;
    _contact.company_id = this.companyId;
    _contact.contact_id = this.contact.contact_id;
    _contact.nickname = controls.nickname.value;
    _contact.first_name = controls.first_name.value;
    _contact.middle_name = controls.middle_name.value;
    _contact.last_name = controls.last_name.value;
    _contact.last_name2 = controls.last_name2.value;
    _contact.entity_id = controls.entity_id.value;
    _contact.email = controls.email.value;
    _contact.gender = controls.gender.value ? controls.gender.value : null;
    _contact.cell_phone =
      controls.cell_phone.value === '' ? null : controls.cell_phone.value.replace(/\D/g, '');
    _contact.phone2 =
      controls.phone2.value === '' ? null : controls.phone2.value.replace(/\D/g, '');
    _contact.home_phone =
      controls.home_phone.value !== null
        ? controls.home_phone.value.replace(/\D/g, '')
        : controls.home_phone.value;
    _contact.fax =
      controls.fax.value !== null ? controls.fax.value.replace(/\D/g, '') : controls.fax.value;
    _contact.state = controls.state.value ? controls.state.value.toUpperCase() : '';
    _contact.pin_number = controls.pin_number.value;
    _contact.city = controls.city.value;
    _contact.zip = controls.zip.value;
    _contact.address_1 = controls.address1.value;
    _contact.address_2 = controls.address2.value;
    _contact.note = controls.note.value;
    _contact.is_active = controls.isActive.value;
    _contact.tags = this.tags.value;
    _contact.urbanization = controls.urbanization.value;
    _contact.preferred_time = controls.preferred_time.value;
    _contact.dob = this.datePipe.transform(controls.dob.value, 'yyyy-MM-dd');
    _contact.extension = controls.extension.value;
    _contact.office_number =
      controls.office_number.value != null
        ? controls.office_number.value.replace(/\D/g, '')
        : controls.office_number.value;
    _contact.language = controls.language_preference.value
      ? {
          id: controls.language_preference.value,
        }
      : null;
    if (this.needToChangeImage || this.needToChange) {
      _contact.avatar = this.basicInfo.avatarUUID;
    } else {
      _contact.avatar = this.contact.avatar;
    }
    for (const [key, value] of Object.entries(_contact)) {
      if (typeof value === 'string') {
        _contact[key] = value.trim();
      }
    }
    return _contact;
  }

  addContact(_contact: ContactModel) {
    this.loadingSubject.next(true);
    this.store.dispatch(new ContactOnServerCreated({ contact: _contact }));
    if (this.subscriptions.find((sub) => sub.id === 4) === undefined) {
      const actionLoadingSubscription = this.store
        .pipe(select(selectContactsActionLoading))
        .subscribe((res) => {
          if (res !== true) {
            this.loadingSubject.next(false);
            if (this.subscriptions.find((sub) => sub.id === 5) === undefined) {
              const errorStateSubscription = this.store
                .pipe(select(selectContactErrorState))
                .subscribe((error) => {
                  if (error) {
                    if (error && error.errors && error.errors[0]) {
                      this.submissionErrorObj = [{ error: error.errors[0].details }];
                    } else {
                      this.submissionErrorObj = [{ error: 'GLOBAL.UNSPECIFIED_ERROR' }];
                    }
                    this.hasSubmissionErrors = true;
                  } else if (this.router.routerState.snapshot.url !== '/lists/contacts') {
                    this.submissionErrorObj = null;
                    this.hasSubmissionErrors = false;
                    const message = this.translate.instant('CONTACT.EDIT.ADD_MESSAGE');
                    this.layoutUtilsService.showActionNotification(
                      message,
                      MessageType.Create,
                      3000,
                      false,
                      false,
                    );
                    this.goBack();
                  }
                });
              this.subscriptions.push({ id: 5, sub: errorStateSubscription });
            }
          }
          this.cdr.detectChanges();
        });
      this.subscriptions.push({ id: 4, sub: actionLoadingSubscription });
      setTimeout(
        () =>
          this.store.pipe(select(selectLastCreatedContact), take(1)).subscribe((val) => {
            if (!val) {
              return;
            }
            this.contact = val;

            // Tabs to display in create contact mode.
            if (this.contact?.id) {
              this.tabs = this.initialTabs.filter((x) => x.index === 0 || x.index === 1);
            }
            this.cdr.detectChanges();
            this.updateContactImage(() => {
              const editedContact = this.prepareContact();
              if (editedContact.id > 0) {
                this.updateContact(editedContact);
                return;
              }

              return null;
            });
          }),
        1000,
      );
    }
  }

  updateContact(_contact: ContactModel) {
    this.loadingSubject.next(true);

    const updateContact: Update<ContactModel> = {
      id: _contact.id,
      changes: _contact,
    };

    this.store.dispatch(
      new ContactOnServerUpdated({
        partialContact: updateContact,
        contact: _contact,
      }),
    );
    if (this.actionLoadingSubscription) {
      this.actionLoadingSubscription.unsubscribe();
    }
    if (this.errorStateSubscription) {
      this.errorStateSubscription.unsubscribe();
    }

    this.actionLoadingSubscription = this.store
      .pipe(select(selectContactsActionLoading))
      .subscribe((res) => {
        if (res !== true) {
          this.loadingSubject.next(false);
          this.errorStateSubscription = this.store
            .pipe(select(selectContactErrorState), take(1))
            .subscribe((error) => {
              if (error) {
                if (error.error && error.error.errors && error.error.errors[0]) {
                  const errorDetails = error.error.errors[0].details;
                  const errorStatus = error.error.errors[0].status;
                  this.submissionErrorObj = [{ error: error.error.errors[0].details }];

                  if (errorStatus === 409 && errorDetails === 'Cell phone already exists') {
                    const latestCellPhone = _contact.cell_phone.trim();

                    if (!this.dialog.openDialogs.length) {
                      this.store.dispatch(setSelectedCellPhone({ cellPhone: latestCellPhone }));

                      this.store
                        .pipe(
                          select(selectSelectedCellPhone),
                          filter((cellPhone) => cellPhone === latestCellPhone),
                          take(1),
                        )
                        .subscribe(() => {
                          this.dialog.open(ContactDuplicateCellNumberComponent, {
                            data: { contact: _contact },
                            width: '70%',
                            height: '500px',
                          });
                        });
                    }
                  }
                } else {
                  this.submissionErrorObj = [{ error: 'GLOBAL.UNSPECIFIED_ERROR' }];
                }
                this.hasSubmissionErrors = true;
              } else if (this.router.routerState.snapshot.url !== '/lists/contacts') {
                let message = '';
                if (!this.needToChangeImage) {
                  message = this.translate.instant('CONTACT.EDIT.UPDATE_MESSAGE');
                  this.layoutUtilsService.showActionNotification(
                    message,
                    MessageType.Update,
                    3000,
                    false,
                    false,
                  );
                  this.goBack();
                } else {
                  this.globalService
                    .getEntitiesById('contacts', this.contact.id)
                    .subscribe((contact) => {
                      if (contact) {
                        this.needToChangeImage = false;
                        this.loadContact(contact.data);
                        this.loadTags();
                        message = 'Contact picture changed successfully';
                        this.layoutUtilsService.showActionNotification(
                          message,
                          MessageType.Update,
                          3000,
                          false,
                          false,
                        );
                        this.cdr.detectChanges();
                        return;
                      }
                    });
                }
              }
            });
        }
        this.cdr.detectChanges();
      });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.contactForm.controls[controlName];
    if (!control) {
      return false;
    }

    return control.hasError(validationType) && (control.dirty || control.touched);
  }
  onAlertClose() {
    this.hasFormErrors = false;
  }

  getStatusString(): string {
    switch (this.contactForm.get('isActive').value) {
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
    }
    return '';
  }

  editContact(id) {
    const queryParams = { viewContext: ViewContext.contacts };
    this.navigationService.navigateTo('lists/contacts/edit/' + id, queryParams);
  }

  private loadTags() {
    if (this.contact)
      this.sharedHttpRequestService
        .getTagsForView(this.contact.id, tagsViewContext.CONTACTS)
        .subscribe(
          (tags) => {
            this.readOnlyTags = tags.data;
            this.tags$.next(tags.data);
            this.loadingTags = false;
          },
          () => {
            this.readOnlyTags = [];
            this.loadingTags = false;
          },
        );
  }

  setMaxDate($event: MatDatepickerInputEvent<any>) {
    this.maxDate = $event.value;
  }

  mergeContact() {
    const dialogRef = this.dialog.open(MergeContactsComponent, {
      data: this.contact,
      width: '600px',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.contacts) {
        const contacts = res.contacts.map((a) => a.id);
        this.contactService.putContactMerge(contacts, this.contact.id).subscribe((ret) => {
          let message = 'Contacts merged successfully!';
          if (ret.status !== 200) message = ret.statusText;
          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Read,
            6000,
            true,
            false,
          );
        });
      }
    });
  }

  putDash(e) {
    let x = e;
    if (x.length === 6 && x.charAt(5) !== '-') {
      x = x.slice(0, 5) + '-' + x.charAt(x.length - 1);
    }
    return x;
  }

  getItemCssClassByStatus(status: boolean): string {
    switch (status) {
      case false:
        return 'danger';
      case true:
        return 'success';
    }
    return '';
  }

  updateProfile() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '600px';
    dialogConfig.height = '400px';
    const defaultImage = this.contact.gender
      ? this.contact.gender === 'FEMALE'
        ? this.contactFemaleDefault
        : this.contactMaleDefault
      : this.contactUndefinedDefault;
    if (this.contact.id) {
      this.globalService.getEntitiesById('contacts', this.contact.id).subscribe((contact) => {
        if (contact?.data) {
          dialogConfig.data = {
            existImage: contact?.data?.pre_signed_url?.url,
            mode: 'UPDATE',
            defaultImage,
          };
          const dialogRef = this.dialog.open(PictureCropperComponent, dialogConfig);
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              switch (result.mode) {
                case 'DELETE': {
                  this.needToChangeImage = true;
                  const editedContact = this.prepareContact();
                  editedContact.avatar = null;
                  if (editedContact.id > 0) {
                    this.updateContact(editedContact);
                    return;
                  }
                  break;
                }
                case 'UPDATE': {
                  if (result.img) {
                    this.newAvatar = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
                    this.needToChangeImage = true;
                    const reader = new FileReader();
                    reader.readAsDataURL(this.newAvatar);
                    reader.onloadend = () => {
                      this.basicInfo.avatar = reader.result;
                      this.cdr.detectChanges();
                    };
                    let editedContact = this.prepareContact();
                    if (editedContact.id > 0) {
                      this.updateContactImage(() => {
                        editedContact = this.prepareContact();
                        if (editedContact.id > 0) {
                          this.updateContact(editedContact);
                          return;
                        }
                        return null;
                      });
                      return;
                    }
                  }
                  break;
                }
              }
            }
          });
        }
      });
    } else {
      dialogConfig.data = { existImage: null, mode: 'UPDATE', defaultImage };
      const dialogRef = this.dialog.open(PictureCropperComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          switch (result.mode) {
            case 'UPDATE': {
              if (result.img) {
                this.newAvatar = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
                this.contactProfile = result.img;
                this.needToChangeImage = true;
                const reader = new FileReader();
                reader.readAsDataURL(this.newAvatar);
                reader.onloadend = () => {
                  this.basicInfo.avatar = reader.result;
                  this.cdr.detectChanges();
                };
              }
              break;
            }
          }
        }
      });
    }
  }
  private updateContactImage(cc) {
    if (this.needToChangeImage) {
      return this.contactService
        .updateContactImage(this.newAvatar, this.contact.id)
        .subscribe((res2) => {
          this.contactService.uploadContactImage(res2, this.newAvatar).subscribe(() => {
            this.basicInfo.avatarUUID = res2.data.uuid;
            cc();
          });
        });
    } else {
      cc();
    }
  }

  viewFiles() {
    const dialogFile = this.dialog.open(ViewFileDialogComponent, {
      data: {
        title: 'Previous photos',
        type: 'contacts',
        id: this.contact.id,
      },
    });
    dialogFile.afterClosed().subscribe((res) => {
      if (res && res.isUpdated && res.pre && res.uuid) {
        const filename = res.uuid.split('/').pop();
        this.newAvatar = { name: filename };
        this.basicInfo.avatar = res.pre;
        this.basicInfo.avatarUUID = res.uuid;
        this.contactProfile = res.pre;
        this.needToChange = true;
        let editedContact = this.prepareContact();
        if (editedContact.id > 0) {
          this.updateContactImage(() => {
            editedContact = this.prepareContact();
            if (editedContact.id > 0) {
              this.updateContact(editedContact);
              return;
            }
            return null;
          });
          return;
        }
        this.cdr.detectChanges();
      }
    });
  }

  showUsername(e) {
    this.contactUsername = e;
    this.cdr.detectChanges();
  }
  changeTab(index) {
    this.tabs = this.tabs.map((item) => {
      item.active = item.index === index;
      return item;
    });
    this.insertParam(index);
  }
  insertParam(value) {
    const queryParams = { tab_index: +value };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
    });
  }
  firstLine() {
    const titleOne = document.querySelector('.title-one') as HTMLElement;
    const text =
      (this.contact.first_name ? this.contact.first_name : '') +
      ' ' +
      (this.contact.middle_name ? this.contact.middle_name : '');
    const textLength = text.length;
    if (titleOne && textLength) {
      const fontSize = Math.floor(220 / textLength);
      const newSize = (fontSize + 5) * 8 - 15;
      titleOne.style.fontSize = textLength < 16 ? 20 + 'px' : newSize + '%';
    }
    return text;
  }
  secondLine() {
    const titleTwo = document.querySelector('.title-two') as HTMLElement;
    const text2 =
      (this.contact.last_name ? this.contact.last_name : '') +
      ' ' +
      (this.contact.last_name2 ? this.contact.last_name2 : '');
    const textLength2 = text2.length;
    if (titleTwo && textLength2) {
      const fontSize2 = Math.floor(220 / textLength2);
      const newSize2 = (fontSize2 + 5) * 8 - 15;
      titleTwo.style.fontSize = textLength2 < 16 ? 20 + 'px' : newSize2 + '%';
    }
    return text2;
  }

  showContactPhoto(contact) {
    if (!this.contact.pre_signed_url?.url) {
      return;
    }
    this.dialog.open(ZoomInEntityComponent, { data: { entity: contact }, maxWidth: '600px' });
  }

  getCustomerID(contact) {
    return contact.contact_uuid;
  }

  sendInvitation(contact_id) {
    if (contact_id) {
      this.contactService.sendInvitation(contact_id).subscribe(
        () => {
          this.layoutUtilsService.showActionNotification(
            'Invitation sent successfully',
            MessageType.Update,
            3000,
            false,
            false,
          );
        },
        () => {
          this.layoutUtilsService.showActionNotification(
            'Something wrong with invitation sent',
            MessageType.Update,
            3000,
            false,
            false,
          );
        },
      );
    }
  }
  goToLastSession(contact) {
    if (!contact.last_registration_session?.id)
      return this.layoutUtilsService.showActionNotification(
        'No Registration Session',
        MessageType.Update,
        3000,
        false,
        false,
      );
    this.router.navigate([`/enrollment-verification/${contact.last_registration_session?.id}`], {
      state: {},
    });
  }
}
